import * as z from "zod";

export const proxySlackImage = {
  name: "proxySlackImage" as const,
  input: z.object({ imageUrl: z.string() }),
  output: z.object({
    // Base64 encoded image data with data URL prefix
    dataUrl: z.string().nullable(),
    error: z.string().nullable(),
  }),
};
